import { Box } from '@mui/material';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import AnimatedTypography from '../../core/AnimatedTypography';
import TermsSectionItem from '../components/TermsSectionItem';

const SECTION_KEYS = [
    'section1',
    'section2',
    'section3',
    'section4',
    'section5',
    'section6',
    'section7',
    'section8',
    'section9',
    'section10',
    'section11',
    'section12',
    'section13',
] as const;

const TermsOfBusinessPage: React.FC = () => {
    const { t } = useTranslation();

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    return (
        <Box mt={{ xs: 8, sm: 10 }} display="flex" flexDirection="column" gap={4}>
            <AnimatedTypography variant="h3" mb={2} color="text2.primary" fontWeight={600}>
                {t('termsOfBusiness.title')}
            </AnimatedTypography>
            <AnimatedTypography variant="subtitle1" color="text.secondary" mb={2}>
                {t('termsOfBusiness.subtitle')}
            </AnimatedTypography>

            {SECTION_KEYS.map((key) => (
                <TermsSectionItem
                    key={key}
                    title={t(`termsOfBusiness.${key}.title`)}
                    description={t(`termsOfBusiness.${key}.content`)}
                />
            ))}
        </Box>
    );
};

export default TermsOfBusinessPage;
